<template>
  <div>
    <div class="choose">
      <van-cell-group @click.native="isYearShow=true">
        <van-field label="学年" placeholder="请选择学年" readonly v-model="selectYear" />
      </van-cell-group>
      <van-cell-group @click.native="isSessionShow=true">
        <van-field label="学期" placeholder="请选择学期" readonly v-model="selectSession" />
      </van-cell-group>
      <van-action-sheet
        v-model="isYearShow"
        :actions="yearData"
        @select="yearSelectFun"
        cancel-text="取消"
        close-on-click-action
      />
      <van-action-sheet
        v-model="isSessionShow"
        :actions="sessionData"
        @select="sessionSelectFun"
        cancel-text="取消"
        close-on-click-action
      />
    </div>
    <div class="report-box" v-for="item in reportList" :key="item">
      <div class="box-herder">
        <div class="plan-name">{{item.AssessProjectName}}</div>
        <p class="release-time">发布时间：{{item.ReleaseDate}}</p>
      </div>
      <div class="box-body" v-for="tItem in item.TeacherReport" :key="tItem">
        <div class="subject-content">
          <div class="subject-one">
            <img :src="require('@/assets/evaluation/myReport1.png')" alt />
            <span class="name nowarp">{{tItem.SubjectName}}</span>
          </div>
          <div class="subject-two">
            <span class="font-style">总结果</span>
            <span class="f44 nowarp" style="color:#198CFF;margin-left:10px">{{tItem.ResultScore}}</span>
          </div>
          <div class="subject-two">
            <span class="font-style">名次</span>
            <span class="f44 nowarp" style="color:#FF7500;margin-left:10px">{{tItem.ObjectRanking}}</span>
          </div>
        </div>
        <div class="subject-score">
          <div class="single" v-if="tItem.arrs1.length">单次</div>
          <div class="score-list" v-if="tItem.arrs1.length">
            <div class="score-one" v-for="child in tItem.arrs1" :key="child">
              <div class="f34 score-num">{{child.TargetScore}} / {{child.SupposedResult}}</div>
              <div class="font-style">{{child.AssessTargetName}} / 赋分</div>
            </div>
          </div>
          <div class="single" v-if="tItem.arrs2.length">增量</div>
          <div class="score-list" v-if="tItem.arrs2.length">
            <div class="score-one" v-for="child in tItem.arrs2" :key="child">
              <div class="f34 score-num">{{child.TargetScore}} / {{child.SupposedResult}}</div>
              <div class="font-style">{{child.AssessTargetName}} / 赋分</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//  import { setTimeout } from "timers";
import xyapi from "@/common/api";
export default {
  data() {
    return {
      reportList: [],
      //学年
      isYearShow: false,
      selectYear: "",
      selectYearId: 0,
      yearData: [{ id: 0, name: "所有学年" }],
      //学期
      isSessionShow: false,
      selectSession: "",
      selectSessionId: 0,
      sessionData: []
    };
  },
  created() {
    this.getYear();
  },
  mounted() {},
  methods: {
    //选中学年
    yearSelectFun(e) {
      this.selectYear = e.name;
      this.selectYearId = e.id;
      //选择学年时把联动的学期置空
      this.getSession(e.id);
    },
    // 选中学期
    sessionSelectFun(e) {
      this.selectSession = e.name;
      this.selectSessionId = e.id;
      this.getReport();
    },
    //获取学年
    async getYear() {
      this.xy.loading();
      let res = await xyapi.get(
        `${this.xyMApi}/xy/comm/YearList`
      );
      this.xy.unloading();
      if (res.success) {
        if (res.data.length > 0) {
          res.data.map(item => {
            if (item.IsCurrent) {
              this.selectYearId = item.ID;
              this.selectYear = item.Name;
              this.getSession(item.ID);
            }
            this.yearData.push({
              id: item.ID,
              name: item.Name
            });
          });
        }
      }
    },
    //获取学期
    async getSession(id) {
      this.xy.loading();
      let res = await xyapi.get(
        `${this.xyMApi}/xy/comm/SessionList`,
        {
          yearID: id
        }
      );
      this.xy.unloading();
      if (res.success) {
        this.selectSession = "";
        this.selectSessionId = 0;
        this.sessionData = [
          {
            id: 0,
            name: "所有学期"
          }
        ];
        res.data.map(item => {
          if (item.IsCurrent) {
            this.selectSessionId = item.AcademicSessionID;
            this.selectSession = item.AcademicSessionName;
          }
          this.sessionData.push({
            id: item.AcademicSessionID,
            name: item.AcademicSessionName
          });
        });
        this.getReport();
      }
    },
    //获取报告
    async getReport() {
      this.xy.loading();
      let res = await xyapi.get(
        `${this.$store.state.apiPath}/api/AssessProjectResult/GetAssessTeacherReport`,
        {
          AcademicYearId: this.selectYearId,
          AcademicSessionId: this.selectSessionId
        }
      );
      this.xy.unloading();
      if (res.success) {
        this.reportList =[];
        if (res.data.length > 0) {
          this.reportList = res.data;
          this.reportList.map(item=>{
            item.TeacherReport.map(item1=>{
              item1["arrs1"]=[];
              item1["arrs2"]=[];
              item1.RatingDetail.map(item2=>{
                if(item2.AssessTargetType===1){
                  item1.arrs1.push(item2)
                }
                if(item2.AssessTargetType===2){
                  item1.arrs2.push(item2)
                }
              })
            })
          })
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
.choose {
  display: flex !important;
  margin: 8px 0;
  /deep/ .van-field__label {
    width: auto !important;
    margin-right: 16px !important;
    span {
      font-size: 28px !important;
    }
  }
  /deep/ .van-field__body {
    input {
      font-size: 28px !important;
    }
  }
}
.report-box {
  .box-herder {
    text-align: center;
    margin: 23px 0 13px;
    .plan-name {
      height: 86px;
      line-height: 86px;
      font-size: 30px;
      font-family: SimHei;
      font-weight: bold;
      color: #fff;
      background-image: url("../../../../../assets/evaluation/myReport.png");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 543px 86px;
    }
    .release-time {
      font-size: 22px;
      font-family: Hiragino Sans GB;
      font-weight: normal;
      color: #999;
      margin-top: 12px;
    }
  }
  .box-body {
    width: 100%;
    padding: 45px 40px 40px 33px;
    background: rgba(255, 255, 255, 1);
    .subject-content {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-bottom: 42px;
      border-bottom: 1px solid rgba(215, 212, 215, 0.5);
      .subject-one {
        flex: 0.7;
        img {
          width: 46px;
          height: 46px;
        }
        .name {
          font-size: 36px;
          font-family: SimHei;
          font-weight: bold;
          color: rgba(1, 1, 1, 1);
          margin-left: 15px;
          vertical-align: middle;
        }
      }
      .subject-two {
        flex: 0.5;
        text-align: right;
      }
    }
    .subject-score {
      margin-top: 28px;
      .single {
        width: 103px;
        height: 44px;
        line-height: 44px;
        text-align: center;
        background: rgba(238, 238, 238, 1);
        border-radius: 0px 22px 22px 0px;
        font-size: 28px;
        color: #333333;
      }
      .score-list {
        margin-top: 30px;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        .score-one {
          width: 33%;
          text-align: center;
          margin-bottom: 40px;
          .score-num {
            margin-bottom: 34px;
          }
        }
      }
    }
    .f44 {
      font-size: 44px;
      font-weight: bold;
    }
    .f34 {
      font-size: 34px;
      font-weight: bold;
      color: #010101;
    }
    .font-style {
      font-size: 24px;
      font-weight: normal;
      color: rgba(122, 122, 122, 1);
    }
  }
}
</style>
